import { Grid, Typography, Divider, Box, Paper, Button } from "@mui/material";
import { useIntl } from "react-intl";
import { Spinner } from "react-bootstrap";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DinamicTable from "components/DinamicTable/DinamicTable";

interface OrdenesCompra {
  id: number;
  estatus: number;
}

interface DetalleInventarioProps {
  verOrdenesCompra?: OrdenesCompra[] | null;
  ordenesCompraPaginadas: OrdenesCompra[];
  procesando: boolean;
  handleisAlertOpenDetalleOrdenCompra: () => void;
  setVerDetalleOrdenCompra: React.Dispatch<React.SetStateAction<any>>;
  getBitacoraOrdenCompra: (datos: any) => Promise<void>;
  handleisAlertOpenBitacora: () => void;
}

const OrdenCompraModulo = ({
  verOrdenesCompra,
  ordenesCompraPaginadas,
  procesando,
  handleisAlertOpenDetalleOrdenCompra,
  setVerDetalleOrdenCompra,
  getBitacoraOrdenCompra,
  handleisAlertOpenBitacora,
}: DetalleInventarioProps) => {
  if (!verOrdenesCompra) return null;
  const intl = useIntl();

  return (
    <Box sx={{ px: 2, pb: 2, mt: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Grid container>
              <Grid item xs={12} md={10}>
                <Typography
                  variant="h6"
                  color="primary"
                  gutterBottom
                  sx={{ color: "#004c93", textAlign: { xs: "center", sm: "left" } }}
                >
                  Ordenes de compra registradas
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={{ m: 2 }} />
            {verOrdenesCompra.length > 0 ? (
              <>
                <DinamicTable
                  key={"tabla"}
                  sinExport
                  canSearch
                  columnsOrder={["id", "id_requisicion", "descripcion", "computo", "estatus_orden"]}
                  data={verOrdenesCompra}
                  esListaRequisicion
                  actions
                  enAccion={(accion, row) => {
                    if (accion === "ver") {
                      const datos = {
                        id_orden_compra: row?.id,
                      };
                      setVerDetalleOrdenCompra(row);
                      handleisAlertOpenDetalleOrdenCompra();
                    }
                    if (accion === "ver_bitacora") {
                      const datos = {
                        id_orden_compra: row?.id,
                      };
                      getBitacoraOrdenCompra(datos);
                      setVerDetalleOrdenCompra(row);
                      handleisAlertOpenBitacora();
                    }
                  }}
                />
              </>
            ) : procesando ? (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <Typography variant="h6" color="text.secondary">
                  {intl.formatMessage({ id: "general_cargando_datos" })}
                </Typography>
                <Spinner animation="border" />
              </Box>
            ) : verOrdenesCompra?.length === 0 && !procesando ? (
              <Box sx={{ textAlign: "center", py: 2 }}>
                <Typography variant="h6" color="text.secondary">
                  {intl.formatMessage({ id: "no_hay_datos_registrados" })}
                </Typography>
              </Box>
            ) : null}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
export default OrdenCompraModulo;
